<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <div class="btn-group-one">
            <el-button type="primary" size="small" @click="addReserveDialogShow"
              >预订桌位</el-button
            >
          </div>
          <div class="btn-group-two">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="allChecked"
              label="全选"
              border
              @change="checkAllChange"
              size="small"
            ></el-checkbox>
            <el-button
              plain
              :disabled="!checkedReserveList.length ? true : false"
              size="small"
              @click="allCancel"
              >取消预订</el-button
            >
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="list" v-loading="isLoading">
          <el-checkbox-group
            v-model="checkedReserveList"
            @change="checkedReserveChange"
          >
            <el-table :data="reserveList" style="width: 100%;">
              <el-table-column label="手机号">
                <template slot-scope="scope">
                  <el-checkbox :label="scope.row.id">
                    <div>{{ scope.row.phoneNumber }}</div>
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                prop="comeTime"
                label="预订时间"
              ></el-table-column>
              <el-table-column label="到店人数">
                <template slot-scope="scope">
                  {{ scope.row.peopleNumber }}人
                </template>
              </el-table-column>
              <el-table-column label="桌位">
                <template slot-scope="scope">
                  {{ scope.row.tableName }}
                </template>
              </el-table-column>
              <el-table-column label="备注" width="300">
                <template slot-scope="scope">
                  {{ scope.row.note }}
                </template>
              </el-table-column>
              <el-table-column label="操作" header-align="right" width="200">
                <template slot-scope="scope">
                  <div class="float-right">
                    <el-button
                      size="small"
                      type="primary"
                      @click="updateAppointment(scope.$index, 1)"
                      >开桌</el-button
                    >
                    <el-button
                      size="small"
                      type="primary"
                      @click="updateAppointment(scope.$index, 2)"
                      plain
                      >取消预订</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogReserveVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">就餐预订</div>
      <el-form
        :model="reserveForm"
        :rules="reserveFormRule"
        ref="reserveForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="到店人数" prop="peopleNumber">
          <el-input
            v-model="reserveForm.peopleNumber"
            :maxlength="15"
            placeholder="请输入到店人数"
          ></el-input>
        </el-form-item>
        <el-form-item label="到店时间" prop="comeTime">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            class="form-date-picker"
            v-model="reserveForm.comeTime"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input
            v-model="reserveForm.phoneNumber"
            :maxlength="15"
            placeholder="请输入预订手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="特殊要求" prop="note">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            v-model="reserveForm.note"
            :maxlength="15"
            placeholder="请填写客户特殊要求"
          ></el-input>
          <div class="text-red">
            <i class="el-icon-warning-outline"></i>
            为客户保留桌位至过时30分钟或手动取消，被预订餐桌可正常使用，
            请酌情保留顾客桌位。
          </div>
        </el-form-item>
        <el-form-item label="餐桌类型" prop="shoppingTableId">
          <el-cascader
            :props="{
              checkStrictly: true,
            }"
            :options="shopTablesOptions"
            v-model="reserveForm.shoppingTableId"
            clearable
            placeholder="请选择餐桌"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createReserve" :loading="isSubmit"
          >预订</el-button
        >
        <el-button @click="dialogReserveVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAppointmentList,
  addReserve,
  updateAppointment,
  getReserveById,
  getShopTables,
  getShopAreas,
  addAppointments,
  getOrderByTable,
} from "@/api";
import { mapState } from "vuex";
export default {
  data() {
    return {
      checkedReserveList: [],
      ReserveTypeList: [],
      ReserveTypeActive: 0,
      reserveList: [],
      dialogReserveVisible: false,
      reserveForm: {
        peopleNumber: "",
        phoneNumber: "",
        note: "",
        comeTime: "",
        shoppingTableId: "",
      },
      reserveFormRule: {
        peopleNumber: [
          {
            required: true,
            message: "请输入到店人数",
            trigger: "blur",
          },
          {
            pattern: /\d+/,
            message: "请输入阿拉伯数字",
            trigger: "blur",
          },
        ],
        phoneNumber: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        comeTime: [
          {
            required: true,
            message: "选择日期时间",
            trigger: "blur",
          },
        ],
        // shoppingTableId: [
        //     {
        //         required: true,
        //         message: "选择餐桌",
        //         trigger: "blur"
        //     }
        // ],
      },
      isSubmit: false,
      isSel: false,
      allChecked: false,
      isIndeterminate: false,
      isLoading: false,
      shopTablesOptions: [],
    };
  },
  mounted() {
    this.getPageData();
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    ReserveListOptions() {
      let options = [];
      this.reserveList.forEach((val) => {
        options.push(val.id);
      });
      return options;
    },
  },
  watch: {},
  methods: {
    getPageData() {
      this.getAppointmentList();
      this.getShopAreas();
    },
    getAppointmentList() {
      getAppointmentList().then((res) => {
        if (res.code == 1) {
          this.reserveList = res.data;
        } else {
          this.reserveList = [];
        }
        this.isLoading = false;
      });
    },
    addReserveDialogShow() {
      this.reserveForm = {
        peopleNumber: "",
        phoneNumber: "",
        note: "",
        comeTime: "",
        shoppingTableId: "",
      };
      this.isSubmit = false;
      this.dialogReserveVisible = true;
    },
    addReserve(params) {
      this.isSubmit = true;
      addAppointments(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "预订成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.dialogReserveVisible = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
      setTimeout(() => {
        this.isSubmit = false;
      }, 500);
    },
    createReserve() {
      this.$refs.reserveForm.validate((valid) => {
        if (valid) {
          // if (!this.reserveForm.shoppingTableId[1]) {
          //     this.$notify({
          //         title: "提示",
          //         message: "请选择餐桌",
          //         type: "error",
          //         duration: 2000
          //     });
          //     return false;
          // } else {
          this.reserveForm.shoppingTableId = this.reserveForm.shoppingTableId[1];
          let params = JSON.parse(JSON.stringify(this.reserveForm));
          this.addReserve(params);
          // }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetCheckedState() {
      this.allChecked = false;
      this.isIndeterminate = false;
      this.isSel = false;
      this.checkedReserveList = [];
    },
    checkAllChange(val) {
      this.checkedReserveList = val ? this.ReserveListOptions : [];
      this.isIndeterminate = false;
      this.isSel = val;
      this.allChecked = val;
    },
    checkedReserveChange(value) {
      let checkedCount = value.length;
      this.allChecked = checkedCount === this.reserveList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.reserveList.length;
      this.isSel = checkedCount > 0;
    },
    updateAppointmentFuc(index, type) {
      updateAppointment({
        status: type,
        appointmentId: this.reserveList[index].id,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: type == 1 ? "开桌成功" : "取消成功",
            type: "success",
            duration: 2000,
          });
          if (type == 1) {
            let item = this.reserveList[index];
            if (item.shoppingTableId) {
              this.$router.push({
                path: `/home/order?shopId=${this.shop.shopId}&shoppingTableId=${
                  item.shoppingTableId
                }&tableName=${item.tableName}&peopleNumber=${
                  item.peopleNumber
                }`,
              });
            } else {
              this.$router.push({
                path: "/",
              });
            }
          }
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    updateAppointment(index, type) {
      if (this.reserveList[index].shoppingTableId && type == 1) {
        this.getOrderByTable(index, () => {
          this.updateAppointmentFuc(index, type);
        });
      } else {
        this.updateAppointmentFuc(index, type);
      }
    },
    getOrderByTable(index, cb) {
      getOrderByTable({
        shoppingTableId: this.reserveList[index].shoppingTableId,
      }).then((tableRes) => {
        if (tableRes.code == -1) {
          cb && cb();
        } else {
          this.$notify({
            title: "提示",
            message: "当前桌子正在被使用，开桌失败",
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getShopAreas() {
      getShopAreas().then((res) => {
        if (res.code == 1) {
          let options = Array.from(res.data).map((item) => ({
            value: item.shopAreaId,
            label: item.areaName,
            children: [],
          }));
          options.forEach((val, index) => {
            getShopTables({
              shopAreaId: val.value,
              row: 1000,
            }).then((res) => {
              if (res.code == 1) {
                let subOptions = Array.from(res.data).map((item) => ({
                  value: item.shoppingTableId,
                  label: item.tableName,
                }));
                val.children = subOptions;
                this.shopTablesOptions = options;
                console.log(this.shopTablesOptions);
              }
            });
          });
        }
      });
    },
    allCancel() {
      this.checkedReserveList.forEach((val, index) => {
        this.updateAppointment(index, 2);
        if (index == this.checkedReserveList.length - 1) {
          this.allChecked = false;
          this.isIndeterminate = false;
          this.checkedReserveList = [];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    .btn-group-two {
      .el-checkbox {
        margin-right: 15px;
      }
    }
  }
  .tab-content {
    display: block;
    padding: 20px;
  }
  .text-red {
    color: #f56c6c;
    line-height: 20px;
    margin-top: 10px;
  }
  .form-date-picker {
    width: 100%;
  }
}
</style>
